import React, { useEffect, useRef, useState } from "react"
import { preventBodyScroll } from "@/utils/helper"
import ImageReel from "@/components/ImageGallery/v3/ImageReel"

const ImageGallery = props => {
  const [showModal, setShowModal] = useState(null)
  const viewBtnRef = useRef()

  useEffect(() => {
    preventBodyScroll(showModal)
    if (showModal) document.body.classList.add("image-gallery-modal-opened")
    else if (showModal === false) {
      document.body.classList.remove(
        "scroll-lock",
        "image-gallery-modal-opened"
      )
      viewBtnRef.current.focus()
    }
  }, [showModal])

  const handleModalPopup = () => {
    setShowModal(true)
  }

  // const isHorizontalView = window?.innerWidth < 1024
  const isHorizontalView = false

  return (
    <ImageReel
      viewBtnRef={viewBtnRef}
      isHorizontal={isHorizontalView}
      handlePopup={handleModalPopup}
      galleryStackId="image-gallery__image-stack-gallery"
      {...props}
    />
  )
}

export default ImageGallery
